import React from 'react'
import { NextPage } from 'next'
import { sendSeriesViewedEvent } from '~/components/AnalyticsProvider'
import { HtmlPageMetadata } from '~/components/HtmlPageMetadata'
import { siteName } from '~/constants/site'
import { Series } from '~/domain/Series'
import { SeriesCollections } from './SeriesCollections'
import { SeriesHeader } from './SeriesHeader'
import { SeriesCollectionsEmptyState } from '~/components/SeriesPage/SeriesCollectionsEmptyState'
import { ChainContext } from '~/context/chain'
import { useAddress, useNetworkMismatch, useSwitchChain } from '@thirdweb-dev/react'

export interface SeriesPageProps {
  series: Series
  url: string
}

export const SeriesPage: NextPage<SeriesPageProps> = ({
  series,
  url,
}) => {
  const { activeChain, setActiveChain } = React.useContext(ChainContext)
  const address = useAddress()
  const isChainMismatch = useNetworkMismatch()
  const switchChain = useSwitchChain()

  const targetChain = series.collections.length > 0
    ? series.collections[0].contract.chainId
    : null

  React.useEffect(() => {
    if (targetChain && activeChain !== targetChain) {
      setActiveChain(targetChain)
    }
  }, [targetChain, activeChain, setActiveChain])

  React.useEffect(() => {
    if (address && targetChain && isChainMismatch) {
      switchChain(targetChain)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [address])

  React.useEffect(() => sendSeriesViewedEvent(series), [series])

  return (
    <>
      <HtmlPageMetadata
        title={ `${series.name} | ${siteName}` }
        description={ series.description }
        url={ url }
        image={ series.headerImageUrlMobile }
      />

      <SeriesHeader series={ series }/>

      { series.collections.length
        ? <SeriesCollections collections={ series.collections }/>
        : <SeriesCollectionsEmptyState series={ series }/>
      }
    </>
  )
}
